import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetDirective } from './let.directive';
import { VarDirective } from './var.directive';
import { ResizeObserverDirective } from './resize-observer.directive';
import { TemplateContextTypeDirective } from './template-context-type.directive';
import { InputAutofocusDirective } from './input-autofocus.directive';
import { PriceCategoryDirective } from './price-category.directive';
import { DisableMatTabsPaginationDirective } from '@shared/directives/disable-mat-tabs-pagination.directive';
import { MaxTabsPerPageDirective } from '@shared/directives/max-tabs-per-page.directive';
import { PanelEventIsolationDirective } from '@shared/directives/panel-event-isolation.directive';
import { ScrollbarAccessDetectorDirective } from '@shared/directives/scrollbar-detector.directive';
import { MatInputIntegersOnlyDirective } from './mat-input-integers-only.directive';
import { MatSelectBlurOnChangeDirective } from './mat-select-blur-on-change.directive';
import { OnlyNumbersWithDotsDirective } from './only-numbers-with-dots.directive';

@NgModule({
  declarations: [
    LetDirective,
    VarDirective,
    ResizeObserverDirective,
    TemplateContextTypeDirective,
    InputAutofocusDirective,
    PriceCategoryDirective,
    DisableMatTabsPaginationDirective,
    MaxTabsPerPageDirective,
    PanelEventIsolationDirective,
    ScrollbarAccessDetectorDirective,
    MatInputIntegersOnlyDirective,
    MatSelectBlurOnChangeDirective,
    OnlyNumbersWithDotsDirective,
  ],
  exports: [
    LetDirective,
    VarDirective,
    ResizeObserverDirective,
    TemplateContextTypeDirective,
    InputAutofocusDirective,
    PriceCategoryDirective,
    DisableMatTabsPaginationDirective,
    MaxTabsPerPageDirective,
    PanelEventIsolationDirective,
    ScrollbarAccessDetectorDirective,
    MatInputIntegersOnlyDirective,
    MatSelectBlurOnChangeDirective,
    OnlyNumbersWithDotsDirective,
  ],
  imports: [CommonModule],
})
export class DirectivesModule {}
